<template>
  <div class='BuildfixIcon'>
    <svg :fill="color" :width="tam" :height="tam" viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
      <g data-name="Layer 19" id="Layer_19">
        <rect height="10" rx="1.5" ry="1.5" width="4" x="10" y="29"/>
        <path d="M61,24a3,3,0,0,0-3-3H44V15a4,4,0,0,0-4-4H24a4,4,0,0,0-4,4v6H6a3,3,0,0,0-3,3v8a3,3,0,0,0,.68,1.88A2.08,2.08,0,0,0,3,35.38V50.62C3,52,4.32,53,6,53H58c1.68,0,3-1,3-2.38V35.38a2.06,2.06,0,0,0-.68-1.5A3,3,0,0,0,61,32ZM27,17H37v4H27ZM58.44,35H56v2.5A3.5,3.5,0,0,1,52.5,41h-1A3.5,3.5,0,0,1,48,37.5V35H16v2.5A3.5,3.5,0,0,1,12.5,41h-1A3.5,3.5,0,0,1,8,37.5V35H5.56C4.7,35,4,34.55,4,34s.7-1,1.56-1H8V30.5A3.5,3.5,0,0,1,11.5,27h1A3.5,3.5,0,0,1,16,30.5V33H48V30.5A3.5,3.5,0,0,1,51.5,27h1A3.5,3.5,0,0,1,56,30.5V33h2.44c.86,0,1.56.45,1.56,1S59.3,35,58.44,35Z"/>
        <rect height="10" rx="1.5" ry="1.5" width="4" x="50" y="29"/>
      </g>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'BuildfixIcon',
  props: {
    tam: {
      type: String,
      default: '22px'
    },
    color: {
      type: String,
      default: '#000000'
    }
  }
}
</script>

<style scoped>
.BuildfixIcon {
}
</style>
